var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInformationsmanagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 539.51 456.108",
    enableBackground: "new 0 0 539.51 456.108",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000158025378283926395080000000487737742847257019_",
    x: 103.472,
    y: 63.074,
    width: 322.14,
    height: 322.14
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000172432734905478722590000007807469355303974825_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158025378283926395080000000487737742847257019_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000172432734905478722590000007807469355303974825_)",
    fill: "none",
    stroke: "#694A94",
    strokeWidth: 8.26,
    d: " M264.542,67.205c-86.676,0-156.94,70.264-156.94,156.939c0,86.676,70.264,156.94,156.94,156.94s156.94-70.264,156.94-156.94 c0-23.683-5.246-46.14-14.639-66.273"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000172432734905478722590000007807469355303974825_)",
    fill: "none",
    stroke: "#290A3D",
    strokeWidth: 8.26,
    d: " M264.542,93.57c-72.114,0-130.574,58.459-130.574,130.574c0,72.113,58.46,130.572,130.574,130.572s130.574-58.459,130.574-130.572"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000172432734905478722590000007807469355303974825_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 8.26,
    d: " M264.542,120.834c-57.057,0-103.31,46.254-103.31,103.311c0,57.056,46.253,103.309,103.31,103.309 c32.846,0,62.113-15.328,81.035-39.223"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000172432734905478722590000007807469355303974825_)",
    fill: "none",
    stroke: "#B2A6C9",
    strokeWidth: 8.26,
    d: " M264.542,148.808c-41.607,0-75.337,33.729-75.337,75.337c0,41.607,33.73,75.337,75.337,75.337s75.337-33.73,75.337-75.337 c0-8.321-1.349-16.327-3.84-23.812"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationsmanagement);
export default __webpack_public_path__ + "static/media/Informationsmanagement.b8050d85583d22b4e280b2af12089ed9.svg";
export { ForwardRef as ReactComponent };